import { render, staticRenderFns } from "./AccountBlock.vue?vue&type=template&id=1e8abf84&"
import script from "./AccountBlock.vue?vue&type=script&lang=js&"
export * from "./AccountBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports